import React, { useState } from "react";
import {  FaUserMd, FaClipboardList, FaMinus, FaPlus, FaFileMedical, FaServer, FaShieldAlt } from "react-icons/fa";
import { AiOutlineApi, AiOutlineSafetyCertificate, AiOutlineAppstore, AiOutlineCheckCircle } from "react-icons/ai";
import { MdSecurity, MdIntegrationInstructions } from "react-icons/md";
import { FaUsersCog, FaUserShield, FaHandshake, FaRegLightbulb,  } from "react-icons/fa";
import Medpalm from "../../../assests/Comprehensive.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "Comprehensive medical consultations and specialist access.",
        description:
            "Our expert healthcare professionals provide thorough medical consultations to assess your health conditions accurately. Gain direct access to specialists across various fields, ensuring that you receive the best medical advice and treatment plans. Whether you need a routine check-up, chronic disease management, or a second opinion, we ensure a seamless and hassle-free experience tailored to your health needs.",
    },
    {
        title: "Seamless claims management and processing",
        description:
            "Managing insurance claims can be overwhelming, but we simplify the process with efficient and automated systems. Our platform ensures quick claim submission, real-time tracking, and minimal paperwork, reducing processing time and errors. With transparent procedures and dedicated support, we help policyholders receive their claims without unnecessary delays, ensuring financial peace of mind during medical emergencies.",
    },
    {
        title: "Round-the-clock emergency assistance and coverage.",
        description:
            "Medical emergencies can occur at any time, which is why our 24/7 emergency assistance ensures immediate response and coverage. From ambulance services and hospital admissions to urgent medical consultations, our dedicated support team is always ready to assist. With a robust network of healthcare providers, we guarantee quick and effective medical attention whenever you need it most.",
    },
    {
        title: "Flexible insurance plans tailored to individual needs",
        description:
            "We understand that healthcare needs vary from person to person. That’s why we offer a wide range of customizable insurance plans to fit your lifestyle, medical history, and financial preferences. Whether you need a basic plan for routine check-ups or a comprehensive package covering major medical treatments, we provide options that offer the best coverage while keeping costs manageable.",
    },
    {
        title: "Dedicated customer care for policyholders",
        description:
            "Our customer support team is committed to assisting policyholders with any queries related to insurance coverage, claims, policy renewals, and benefits. We provide clear and detailed guidance on policy terms, ensuring that you fully understand your healthcare benefits. With personalized assistance and prompt resolutions, we make sure that managing your insurance is a hassle-free experience.",
    },
];

const features = [
    { text: "Comprehensive access to patient-controlled data sharing.", icon: <AiOutlineApi className="text-[#2a627a] text-xl" /> },
    { text: "Real-time access to Medicare claims and records.", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
    { text: "Seamless integration with third-party healthcare applications.", icon: <AiOutlineAppstore className="text-[#2a627a] text-xl" /> },
    { text: "Enhanced security through OAuth 2.0 authentication.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
    { text: "Customizable access permissions ensuring patient privacy.", icon: <FaUsersCog className="text-[#2a627a] text-xl" /> },
    { text: "Effortless interoperability with EHR systems.", icon: <MdIntegrationInstructions className="text-[#2a627a] text-xl" /> },
];

const benefits = [
    { text: "Minimizes out-of-pocket expenses for patients.", icon: <FaUserShield className="text-[#2a627a] text-xl" /> },
    { text: "Provides financial security for unexpected medical costs.", icon: <FaHandshake className="text-[#2a627a] text-xl" /> },
    { text: "Encourages preventive care and early diagnosis.", icon: <FaRegLightbulb className="text-[#2a627a] text-xl" /> },
    { text: "Improves access to specialists and advanced treatments.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
    { text: "Ensures compliance with healthcare regulations.", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
    { text: "Supports continuity of care through comprehensive plans.", icon: <AiOutlineCheckCircle className="text-[#2a627a] text-xl" /> },
];
const cmsFeatures = [
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Compliance with CMS guidelines for patient protection." },
    { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Standardized coverage criteria for all beneficiaries." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Enhanced accessibility to necessary medical treatments." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Ensures seamless claims processing and approvals." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Facilitates transparent communication with providers." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Maintains patient data privacy and security measures." },
];

const Comprehensive = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Comprehensive Coverage  </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        Access a wide range of healthcare services, from routine check-ups to specialized treatments.
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">Comprehensive Coverage?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Our integration solutions ensure complete access to essential healthcare data, enabling seamless
                            interoperability between systems. With secure APIs and FHIR compliance, we provide real-time connectivity,
                            empowering healthcare providers and patients with accurate, up-to-date medical information.
                        </p>
                    </div>

                </section>

                {/* Role in CMS Compliance */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in CMS Compliance
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Comprehensive;
